import {AxiosError} from "axios";
import {ApiConfig} from "components/src/api/portal/ApiConfig";
import {EnterprisePortalApi} from "components/src/api/portal/generated";
import {useSpinnerStatusContext} from "components/src/hook/UseSpinnerStatusContext";
import {SideBar} from 'components/src/sidebar/SideBar'
import {logger} from "components/src/utils/Logger";
import {Utils} from "components/src/utils/Utils";
import {Home as HomeIcon, Mail as MessagesIcon, PrivacyPolicy as PdfIcon} from "iconoir-react";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

/*
 * REST api for accessing the back-end
 */
const enterprisePortalApi = new EnterprisePortalApi(ApiConfig.config());

/**
 * AppSidebar component provides the main navigation sidebar of the application.
 */
export const EnterprisePortalSidebar = () =>
{
    /**
     * Navigate is used to navigate to the login page if the user is no longer authenticated or to some other page
     * if the dialog is closed
     */
    const navigate = useNavigate();
    /**
     * True if PDF is enabled
     */
    const [pdfEnabled, setPdfEnabled] = useState<boolean>(false);
    /**
     * True if webmail is enabled
     */
    const [webmailEnabled, setWebmailEnabled] = useState<boolean>(false);
    /**
     * Keeps track of activities for which the spinner should be shown. If an activity is started, the counter should
     * be increased by one and after the activity
     */
    const {setSpinnerStateCounter} = useSpinnerStatusContext();
    /**
     * i18next translation hook
     */
    const {t} = useTranslation();

    useEffect(() => {
        if (setSpinnerStateCounter !== undefined) {
            setSpinnerStateCounter(count => count + 1);
        }

        enterprisePortalApi.enterprisePortalControllerGetEnterprisePortalProperties()
            .then(response => {
                setPdfEnabled(response.data.pdfEnabled);
                setWebmailEnabled(response.data.webmailEnabled);
            })
            .catch((err: Error | AxiosError) => {
                logger.error("Error getting webmail enabled", err);
                Utils.redirectToLoginIfNotAuthenticated(err, navigate);
            })
            .finally(() => {
                if (setSpinnerStateCounter !== undefined) {
                    setSpinnerStateCounter(count => count - 1);
                }
            });
    }, [navigate,
        setSpinnerStateCounter,
        t]);

    return (
        <SideBar>
            <SideBar.Item title={t('portal.sidebar.home-title')} link="/" icon={<HomeIcon/>}/>
            {pdfEnabled &&
                <SideBar.Item title={t('portal.sidebar.pdf-password-title')} link="/pdf/otp" icon={<PdfIcon/>}/>
            }

            {webmailEnabled &&
                <SideBar.Item title={t('portal.sidebar.messages-title')} link="/messages" icon={<MessagesIcon/>}/>
            }
        </SideBar>
    )
}
